// extracted by mini-css-extract-plugin
export default {"wrapper":"Error_wrapper__DjcOU","text":"Error_text__1pfom"};